import { fetcher } from "@/shared/lib/fetcher.client";
import { VoucherCategoriesResponse } from "@/shared/types/voucherCategories.types";

export const voucherCategoriesService = {
  async getVoucherCategories(): Promise<VoucherCategoriesResponse> {
    const response = await fetcher<VoucherCategoriesResponse>("/voucher_categories");
    return response.data;
  },
};
